import React from "react";
import { Navigate, Outlet } from "react-router-dom";
import { lawyerAuth } from "../../services/lawyerApi";
import "./lawyerTheme";

// Only reachable with a lawyer session; otherwise back to the login screen.
export const LawyerPrivateRoute = () =>
  lawyerAuth.isLoggedIn() ? <Outlet /> : <Navigate to="/lawyer/login" replace />;

// Login / OTP screens — skip them when already signed in.
export const LawyerGuestRoute = () =>
  lawyerAuth.isLoggedIn() ? <Navigate to="/lawyer/dashboard" replace /> : <Outlet />;

export const LawyerIndexRedirect = () => (
  <Navigate to={lawyerAuth.isLoggedIn() ? "/lawyer/dashboard" : "/lawyer/login"} replace />
);
